// src/components/StepBar.jsx
import React from "react";

/**
 * StepBar
 * props:
 *  - steps: string[]
 *  - current: number (0-index; which step is active)
 */
export default function StepBar({ steps = [], current = 0 }) {
  const clampedCurrent =
    steps.length === 0
      ? 0
      : Math.min(Math.max(current, 0), steps.length - 1);

  // how much of the bar should be filled (0, 50, 100 for 3 steps)
  const pct =
    steps.length <= 1
      ? 0
      : (clampedCurrent / (steps.length - 1)) * 100;

  return (
    <div
      style={wrap}
      role="list"
      aria-label="Signup progress"
    >
      <div style={dotsRow}>
        {steps.map((label, i) => {
          const done = i < clampedCurrent;
          const active = i === clampedCurrent;

          return (
            <div
              key={label}
              style={stepCol}
              role="listitem"
              aria-current={active ? "step" : undefined}
            >
              <div
                style={{
                  ...dot,
                  ...(done ? dotDone : {}),
                  ...(active ? dotActive : {}),
                }}
              >
                {done ? "✓" : i + 1}
              </div>
              <div
                style={{
                  ...lbl,
                  ...(active ? lblActive : {}),
                }}
              >
                {label}
              </div>
            </div>
          );
        })}
      </div>

      {steps.length > 1 && (
        <div style={track} aria-hidden="true">
          <div
            style={{
              ...trackFill,
              width: `${pct}%`,
            }}
          />
        </div>
      )}
    </div>
  );
}

const wrap = {
  width: "100%",
  maxWidth: 260, // keeps it neat in the Signup header
};

const dotsRow = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: 12,
};

const stepCol = {
  display: "grid",
  justifyItems: "center",
  textAlign: "center",
  flex: 1,
  minWidth: 0,
};

const dot = {
  width: 26,
  height: 26,
  borderRadius: 999,
  display: "grid",
  placeItems: "center",
  fontWeight: 800,
  fontSize: 13,
  border: "1px solid var(--border)",
  background: "#fff",
  color: "#3a4150",
  transition: "all .25s ease",
};

const dotActive = {
  background: "linear-gradient(90deg,var(--nav-accent),var(--nav-accent-2))",
  color: "#fff",
  borderColor: "transparent",
  boxShadow: "0 8px 20px rgba(110,91,255,.22)",
};

const dotDone = {
  background: "#eef2ff",
  color: "#312e81",
  borderColor: "#d6d9ff",
};

const lbl = {
  marginTop: 4,
  fontSize: 11,
  lineHeight: 1.1,
  color: "#9ca3af",
  fontWeight: 700,
  whiteSpace: "nowrap",
};

const lblActive = {
  color: "#111827",
};

const track = {
  marginTop: 10,
  height: 2,
  borderRadius: 999,
  background: "linear-gradient(90deg,#eef2ff,#e5e7f0)",
  overflow: "hidden",
};

const trackFill = {
  height: "100%",
  borderRadius: 999,
  background: "linear-gradient(90deg,#6E5BFF,#A78BFA)",
  transition: "width .3s ease",
  width: "0%",
};
